<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <div class="fictive-pallet-input">
          <span class="settings">{{ $t("fictive_pallet_maker.fictive_pallet_settings") }}:</span>
          <v-textarea
            id="comment-input"
            v-model="palletInput.comment"
            :label="$t('fictive_pallet_maker.comment')"
            :hint="$t('fictive_pallet_maker.comment')"
          ></v-textarea>
          <v-text-field
            v-model="palletInput.length"
            type="number"
            min="0"
            step="100"
            :label="$t('fictive_pallet_maker.length')"
          ></v-text-field>
          <v-text-field
            v-model="palletInput.width"
            type="number"
            min="0"
            step="100"
            :label="$t('fictive_pallet_maker.width')"
          ></v-text-field>
          <v-text-field
            v-model="palletInput.height"
            type="number"
            min="0"
            step="10"
            :label="$t('fictive_pallet_maker.height')"
          ></v-text-field>
          <v-text-field
            v-model="palletInput.productHeight"
            type="number"
            min="0"
            step="10"
            :label="$t('fictive_pallet_maker.product_height')"
          ></v-text-field>
          <div class="dialog-buttons">
            <div class="confirm-button">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="createDisabled"
                    color="green"
                    v-on="on"
                    @click="createFictivePallet"
                  >
                    <v-icon color="white">done</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("fictive_pallet_maker.confirm") }}</span>
              </v-tooltip>
            </div>
            <div class="cancel-button">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="red" @click="dialog = false" v-on="on">
                    <v-icon color="white">close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("fictive_pallet_maker.cancel") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
import Pallet from "@/models/Pallet.js";
export default {
  props: ['orders'],
  data() {
    return {
      dialog: false,
      palletInput: {
        length: 1200,
        width: 800,
        height: 120,
        productHeight: 100,
        comment: ""
      },
      onKeyUp: e => {
        if (e.key === "Enter") {
          this.createFictivePallet();
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  computed: {
    createDisabled() {
      if (this.palletInput.length <= 0 || !this.palletInput.length) return true;
      if (this.palletInput.width <= 0 || !this.palletInput.width) return true;
      if (this.palletInput.height <= 0 || !this.palletInput.height) return true;
      if (
        this.palletInput.productHeight <= 0 ||
        !this.palletInput.productHeight
      )
        return true;
      if (this.palletInput.comment == "" || !this.palletInput.comment)
        return true;
      return false;
    }
  },
  methods: {
    async open() {
      this.dialog = true;
      await Helper.timeout(50);
      document.getElementById("comment-input").focus();
    },

    async createFictivePallet() {
      if (this.createDisabled) return;
      const isFocused =
        document.activeElement == document.getElementById("comment-input");
      if (isFocused) return;
      this.$store.commit('setLoading', true);
      await Pallet.createFictivePallet(this.palletInput, this.orders[0]);
      this.dialog = false;
      this.$store.commit('setLoading', false);
      this.$emit('created');
    }
  }
};
</script>

<style scoped>
.fictive-pallet-input {
  min-height: 600px;
  padding: 20px 20px 20px 20px;
}
.dialog-buttons {
  position: absolute;
  bottom: 20px;
  width: calc(100% - 40px);
}
.cancel-button {
  position: absolute;
  right: 0px;
}
</style>